import { render, staticRenderFns } from "./Ranking.vue?vue&type=template&id=9b6526ac"
import script from "./Ranking.vue?vue&type=script&lang=js"
export * from "./Ranking.vue?vue&type=script&lang=js"
import style0 from "./Ranking.vue?vue&type=style&index=0&id=9b6526ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports